import { render, staticRenderFns } from "./RelatoriosLinkados.vue?vue&type=template&id=0068b9dc&"
import script from "./RelatoriosLinkados.vue?vue&type=script&lang=js&"
export * from "./RelatoriosLinkados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports